import { api } from "@/lib/api";

let cache = { delta_big_threshold: 5, watch_live_url: "", inactive_logo_url: "" };
let fetched = false;
let pending = null;
const subscribers = new Set();

export const getCachedSettings = () => cache;

export const fetchSettings = async () => {
  if (pending) return pending;
  pending = api.get("/settings").then(({ data }) => {
    cache = {
      delta_big_threshold: parseInt(data?.delta_big_threshold ?? 5) || 5,
      watch_live_url: data?.watch_live_url || "",
      inactive_logo_url: data?.inactive_logo_url || "",
    };
    fetched = true;
    subscribers.forEach((cb) => { try { cb(cache); } catch (_e) { /* noop */ } });
    return cache;
  }).catch(() => cache).finally(() => { pending = null; });
  return pending;
};

export const subscribeSettings = (cb) => {
  subscribers.add(cb);
  if (!fetched) fetchSettings();
  return () => subscribers.delete(cb);
};

export const invalidateSettings = () => { fetched = false; fetchSettings(); };
